export const makeComponentClassList = (props: object) => {
    return Object.entries(props)
        .filter(([key]) => key.startsWith("-"))
        .reduce(
            (__class, [key, value]) => `${__class}${value ? " " + key : ""}`,
            ""
        );
}